import { NcwOnboardingSlideTwo } from '@capsicum/common';
import { Button, Text } from '@capsicum/common-web';
import { type SlideProps } from '@capsicum/features/nc-onboarding/shared';
import styled from 'styled-components';

import { useOnboardingSlidesTranslations } from '../../../hooks/onboarding/useOnboardingSlidesTranslations';
import { Shell } from '../../shell';
import { Description, Title } from '../Page.styled';

export const SecondSlide = ({ onNextSlide }: SlideProps) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell
			cta={<Button testID="ncOnboarding-next-button" text={$t('ncOnboard.actions.next')} onClick={onNextSlide} />}
			image={NcwOnboardingSlideTwo}
		>
			<S.ComingSoonWrapper color="timer.upcoming" variant="text1">
				{$t('ncOnboard.comingSoon')}
			</S.ComingSoonWrapper>

			<Title color="onDark.enabled" variant="display2">
				{$t('ncOnboard.secondSlide.title')}
			</Title>

			<Description color="onDark.enabled" variant="text2">
				{$t('ncOnboard.secondSlide.description')}
			</Description>
		</Shell>
	);
};

namespace S {
	export const ComingSoonWrapper = styled(Text)`
		border-style: solid;
		${({ theme }) => theme.border.radius.small};
		border-width: ${({ theme }) => theme.border.width.small};
		border-color: ${({ theme }) => theme.colors.borders.timer.upcoming};
		background: ${({ theme }) => theme.colors.backgrounds.timer.upcoming};
		padding: ${({ theme }) => theme.spacings.xxxsmall} ${({ theme }) => theme.spacings.xxsmall};
		margin: ${({ theme }) => `0 auto ${theme.spacings.xsmall}`};
	`;
}
